import type { ShiftSummary } from '@/features/shifts/schemas';

interface ShiftSummaryPanelProps {
  summary: ShiftSummary;
}

export function ShiftSummaryPanel({ summary }: ShiftSummaryPanelProps) {
  return (
    <section
      aria-label="Resumo do plantão"
      className="rounded-md border border-(--color-border) bg-(--color-surface) p-4"
    >
      <h2 className="font-display text-lg font-semibold">Resumo do plantão</h2>
      <p className="mt-1 text-sm text-(--color-fg-muted)">
        Valor fixo: {brl(summary.fixedValue)}
      </p>
      {summary.items.length === 0 ? (
        <p className="mt-3 text-sm text-(--color-fg-muted)">
          Nenhum procedimento registrado.
        </p>
      ) : (
        <table className="mt-3 w-full text-sm">
          <thead className="text-xs text-(--color-fg-muted)">
            <tr>
              <th className="py-1 text-left font-medium">Procedimento</th>
              <th className="py-1 text-right font-medium">Qtd</th>
              <th className="py-1 text-right font-medium">Valor un.</th>
              <th className="py-1 text-right font-medium">Subtotal</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-(--color-border)">
            {summary.items.map((i) => (
              <tr key={i.examTypeId}>
                <td className="py-1.5">{i.examTypeName}</td>
                <td className="py-1.5 text-right tabular-nums">{i.qty}</td>
                <td className="py-1.5 text-right tabular-nums">{brl(i.unitValue)}</td>
                <td className="py-1.5 text-right tabular-nums">{brl(i.subtotal)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className="mt-4 flex items-center justify-between border-t border-(--color-border) pt-3">
        <span className="text-sm font-medium">Total</span>
        <span className="font-display text-xl font-semibold text-(--color-accent) tabular-nums">
          {brl(summary.total)}
        </span>
      </div>
    </section>
  );
}

function brl(v: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
}
